// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"55518bd3","65":"e110472b","165":"c918bc87","224":"0acc3ae6","272":"a9a2900d","419":"5d7279dd","787":"80248a08","800":"a6533231","921":"9034b569","937":"ececed2f","968":"26b12090"}[chunkId] + ".chunk.js";
};